import { supabase } from './supabase'
import type { EventShare, GroupShare } from '../types/share'

export async function fetchEventShare(id: string): Promise<EventShare | null> {
  const { data, error } = await supabase.rpc('get_event_preview', { p_event_id: id })
  if (error) throw error
  return data as EventShare | null
}

export async function fetchGroupShare(id: string): Promise<GroupShare | null> {
  const { data, error } = await supabase.rpc('get_group_preview', { p_group_id: id })
  if (error) throw error
  return data as GroupShare | null
}
